/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { trackCaptureEvent } from "@eisinc/App/CoveoConnector/Services/CoveoService";
import { getCoveoSettingsCollection } from "@eisinc/App/CoveoConnector/Store/Selectors/SettingsSelectors";
import { CaptureEventRequest } from "@eisinc/App/CoveoConnector/Types/schema";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as PlaceOrderChain,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export const _CoveoPlaceOrder: any = (props: any) => {
    const state = props.getState();
    const isConfiguredForCoveo = getCoveoSettingsCollection(state).coveoSettings.isConfiguredForCoveo;

    if (isConfiguredForCoveo && window) {
        const cart = props.apiResult.cart;
        const session = getSession(props.getState());

        if (!cart || !window) {
            return;
        }

        const cartLines = props.apiParameter?.cart?.cartLines || [];

        const captureEventParameter: CaptureEventRequest = {
            pageUrl: `${window.location.origin}/OrderConfirmation`,
            eventName: "purchase",
            webOrderNumber: cart.orderNumber,
            orderTotal: cart.orderGrandTotal,
            currencyCode: session.currency?.currencyCode,
            products: [],
            searchHub: "listing",
        };

        cartLines.forEach((cartLine: any, index: number) => {
            const isVariantProduct = cartLine.properties?.isVariantProduct?.toLowerCase() === "true";

            captureEventParameter.products.push({
                productId: isVariantProduct ? cartLine.properties.parentProductId : cartLine.productId,
                productName: isVariantProduct ? cartLine.properties.parentProductShortDescription : cartLine.shortDescription,
                price: cartLine.pricing?.unitListPrice,
                brand: cartLine.brand?.name as string,
                currencyCode: session.currency?.currencyCode,
                quantity: cartLine.qtyOrdered,
                variantErpNumber: isVariantProduct ? cartLine.erpNumber : null,
            });
        });

        trackCaptureEvent(captureEventParameter);
    }
};

addToChainAfter(PlaceOrderChain, UpdateCart, _CoveoPlaceOrder);
